import BlurFade from '../../ui/BlurFade';
import ProjectCard from './ProjectCard';
import { projects } from '../../../data/projects';

const FEATURED_IDS = [10, 11, 12];

const Projects = () => {
  const rest = projects
    .filter((p) => !FEATURED_IDS.includes(p.id))
    .sort((a, b) => (a.live ? 0 : 1) - (b.live ? 0 : 1));

  return (
    <section id="projects" className="bg-black py-20 text-white">
      <div className="mx-auto max-w-5xl px-6">
        <BlurFade>
          <h2 className="mb-10 text-2xl font-black sm:text-3xl">
            More <span className="text-white/40">Projects</span>
          </h2>
        </BlurFade>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {rest.map((project, i) => (
            <BlurFade key={project.id} delay={(i % 6) * 0.05}>
              <ProjectCard project={project} index={i} />
            </BlurFade>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
